module.exports = __webpack_public_path__ + "static/media/employee.b56aa93f.png";